import React, { ReactChild } from 'react';

interface ChildProps {
  children: ReactChild | ReactChild[];
  iframeContainerCssClass?: string;
  mainContainerCssClass?: string;
}

export default function StatusViewContainer({
  children,
  iframeContainerCssClass,
  mainContainerCssClass,
}: ChildProps): JSX.Element {
  return (
    <div
      data-testid="IFRAME_VIEW_CONTAINER"
      id="iframeViewContainer"
      data-iframe-height
      className={`iframe-view-container max-w-xl ${iframeContainerCssClass}`}
    >
      <div
        className={`mainContainer wide:px-10 medium:px-6 justify-center items-center flex flex-col relative ${mainContainerCssClass}`}
      >
        {children}
      </div>
    </div>
  );
}

StatusViewContainer.defaultProps = {
  iframeContainerCssClass: '',
  mainContainerCssClass: '',
};
